var chunkToChildrenMap = {
	"12": [
		7987,
		9455
	],
	"2699": [
		9154,
		1478,
		2786,
		2106,
		9458,
		3215,
		8727,
		6221
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };